var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", { staticClass: "prospectus-info-row" }, [
    _c(
      "td",
      {
        staticClass: "prospectus-info-td",
        attrs: {
          colspan:
            _vm.prospectusTypesWithListing.includes(
              _vm.lastSearchParams.ProspectusType
            ) || _vm.lastSearchParams.ProspectusType === undefined
              ? 5
              : 4
        }
      },
      [
        _c(
          "div",
          { staticClass: "prospectus-info-div row" },
          [
            _c("div", { staticClass: "clearfix" }, [
              _c(
                "div",
                { staticClass: "col" },
                [
                  _vm.prospectus.prospectusType === 4
                    ? [
                        _c(
                          "table",
                          {
                            staticClass:
                              "supplements prospectus-item-info-table"
                          },
                          [
                            _c("thead", [
                              _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.conf.translations.securitiestype)
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.conf.translations.competentauthority
                                    )
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.conf.translations.prospectusid)
                                  )
                                ])
                              ])
                            ]),
                            _vm._v(" "),
                            _c("tbody", [
                              _c("tr", [
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.translatedInfo(
                                          _vm.prospectus,
                                          "additionalInfo"
                                        )
                                      ) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(
                                        _vm.prospectus.competentAuthority
                                      ) +
                                      "\n                                    "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.prospectus.nationalIdentifier)
                                  )
                                ])
                              ])
                            ])
                          ]
                        )
                      ]
                    : _c(
                        "ul",
                        { staticClass: "prospectus" },
                        [
                          _c("h4", [
                            _vm._v(_vm._s(_vm.conf.translations.prospectus))
                          ]),
                          _vm._v(" "),
                          _vm._l(
                            _vm.prospectus.prospectusFiles
                              .concat()
                              .sort(function(a, b) {
                                return a.orderNumber - b.orderNumber
                              }),
                            function(file) {
                              return _c("li", { key: file.fileId }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { title: file.fileName, href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.LoadFile(file)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(file.fileName))]
                                ),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.IsFileLoading(file.fileId),
                                      expression: "IsFileLoading(file.fileId)"
                                    }
                                  ],
                                  staticClass: "loading-spinner"
                                })
                              ])
                            }
                          )
                        ],
                        2
                      )
                ],
                2
              )
            ]),
            _vm._v(" "),
            _vm.prospectus.supplementFiles &&
            _vm.prospectus.supplementFiles.length > 0
              ? [
                  _c(
                    "table",
                    { staticClass: "supplements prospectus-item-info-table" },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("td", [
                            _vm._v(_vm._s(_vm.conf.translations.supplements))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.conf.translations.approvalDate))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(
                          _vm.prospectus.supplementFiles
                            .concat()
                            .sort(function(a, b) {
                              return a.orderNumber - b.orderNumber
                            }),
                          function(supplement) {
                            return _c("tr", { key: supplement.fileId }, [
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "#",
                                      title: supplement.fileName
                                    },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.LoadFile(supplement)
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(supplement.fileName))]
                                ),
                                _c("div", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.IsFileLoading(
                                        supplement.fileId
                                      ),
                                      expression:
                                        "IsFileLoading(supplement.fileId)"
                                    }
                                  ],
                                  staticClass: "loading-spinner"
                                })
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.FormatDate(
                                      supplement.supplementApprovalDate
                                    )
                                  )
                                )
                              ])
                            ])
                          }
                        )
                      )
                    ]
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.prospectus.referencedFiles &&
            _vm.prospectus.referencedFiles.length > 0
              ? [
                  _c("h4", [
                    _vm._v(
                      _vm._s(
                        _vm.conf.translations.documentsIncorporatedByReference
                      )
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "documents-incorporated-by-reference" },
                    _vm._l(_vm.prospectus.referencedFiles, function(doc) {
                      return _c("li", { key: doc.fileid }, [
                        _c(
                          "a",
                          {
                            attrs: { title: doc.filename, href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.LoadFile(doc)
                              }
                            }
                          },
                          [_vm._v(_vm._s(doc.fileName))]
                        ),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.IsFileLoading(doc.fileid),
                              expression: "IsFileLoading(doc.fileid)"
                            }
                          ],
                          staticClass: "loading-spinner"
                        })
                      ])
                    })
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.prospectus.finalTermsFiles &&
            _vm.prospectus.finalTermsFiles.length > 0
              ? [
                  _c("h4", [_vm._v(_vm._s(_vm.conf.translations.finalTerms))]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "documents-incorporated-by-reference" },
                    _vm._l(_vm.prospectus.finalTermsFiles, function(doc) {
                      return _c("li", { key: doc.fileid }, [
                        _c(
                          "a",
                          {
                            attrs: { title: doc.filename, href: "#" },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                _vm.LoadFile(doc)
                              }
                            }
                          },
                          [_vm._v(_vm._s(doc.fileName))]
                        ),
                        _c("div", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.IsFileLoading(doc.fileid),
                              expression: "IsFileLoading(doc.fileid)"
                            }
                          ],
                          staticClass: "loading-spinner"
                        })
                      ])
                    })
                  )
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.prospectus.notificationSupplements &&
            _vm.prospectus.notificationSupplements.length > 0
              ? [
                  _c(
                    "table",
                    {
                      staticClass:
                        "term-sheet-for-bonds prospectus-item-info-table"
                    },
                    [
                      _c("thead", [
                        _c("tr", [
                          _c("td", [
                            _vm._v(_vm._s(_vm.conf.translations.supplements))
                          ]),
                          _vm._v(" "),
                          _c("td", [
                            _vm._v(_vm._s(_vm.conf.translations.approvalDate))
                          ])
                        ])
                      ]),
                      _vm._v(" "),
                      _c(
                        "tbody",
                        _vm._l(
                          _vm.prospectus.notificationSupplements
                            .concat()
                            .sort(function(a, b) {
                              return a.orderNumber - b.orderNumber
                            }),
                          function(supplement) {
                            return _c("tr", { key: supplement.fileId }, [
                              _c("td", [
                                _vm._v(_vm._s(supplement.supplementName))
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(
                                  _vm._s(
                                    _vm.FormatDate(supplement.supplementDate)
                                  )
                                )
                              ])
                            ])
                          }
                        )
                      )
                    ]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f2435972", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f2435972","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./source/js/Prospectus3Page/src/ProspectusItemInfo.vue
// module id = 300
// module chunks = 1